import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUser, FiActivity, FiServer, FiGlobe } = FiIcons;

const Solutions = () => {
  const personas = [
    {
      title: "For Clinicians",
      description: "Build triage tools and protocol assistants without writing a single line of code. Use our visual builder to digitize your clinical expertise.",
      icon: FiUser,
      tag: "Zero-Code"
    },
    {
      title: "For Health-Tech Founders",
      description: "Accelerate your time-to-market. Use HDAI to build, validate, and deploy HIPAA-compliant backends in days, not months.",
      icon: FiGlobe,
      tag: "Hybrid-Mode"
    },
    {
      title: "For Health Systems",
      description: "Deploy standardized, governed clinical logic across your entire organization. Ensure every department follows validated best practices.",
      icon: FiServer,
      tag: "Enterprise"
    }
  ];

  return (
    <div className="pt-24 pb-20 bg-brand-ivory min-h-screen">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h1 className="text-5xl font-display font-bold text-brand-indigo mb-6">Tailored Solutions</h1>
          <p className="text-xl text-brand-slate max-w-3xl mx-auto leading-relaxed">
            HDAI Software scales with your needs, providing the right tools for every member of the healthcare ecosystem.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {personas.map((p, i) => (
            <motion.div 
              key={i}
              className="bg-white p-10 rounded-[2.5rem] border border-gray-100 shadow-sm relative overflow-hidden group"
            >
              <div className="absolute top-6 right-6 px-3 py-1 bg-brand-mint/20 text-brand-indigo text-[10px] font-bold rounded-full uppercase tracking-widest">
                {p.tag}
              </div>
              <div className="w-14 h-14 bg-brand-indigo rounded-2xl flex items-center justify-center mb-8 text-brand-mint group-hover:scale-110 transition-transform">
                <SafeIcon icon={p.icon} className="text-2xl" />
              </div>
              <h3 className="text-2xl font-bold text-brand-indigo mb-4">{p.title}</h3>
              <p className="text-brand-slate leading-relaxed mb-8">{p.description}</p>
              <button className="text-brand-indigo font-bold flex items-center space-x-2 group-hover:translate-x-2 transition-transform">
                <span>Explore Solution</span>
                <SafeIcon icon={FiIcons.FiArrowRight} />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Solutions;